import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LinkFont, SecondaryText, View } from 'modules/styled';
import AsyncSelect from 'react-select/async';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { searchUser } from 'modules/user/user.actions';

class AsyncAdminField extends Component {
  static propTypes = {
    input: PropTypes.object,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    error: PropTypes.string,
    actions: PropTypes.object,
    // userSearch: PropTypes.array
  };

  state = { inputValue: '' };

  handleInputChange = (newValue) => {
    const inputValue = newValue.replace(/\W/g, '');
    this.setState({ inputValue });
    return inputValue;
  };

  loadOptions = async (val) => {
    if (!val.length) return null;
    const userSearch = await this.props.actions.searchUser(val);
    return userSearch.map((u) => ({ label: u.handle, value: u.handle }));
  };

  handleChange = (vals) => {
    const formattedVals = vals.map((v) => v.value);
    this.props.input.onChange(formattedVals);
  };

  render() {
    const { label, error, input } = this.props;
    const vals = (input?.value || []).map((u) => ({ label: u, value: u }));
    return (
      <View sx={{ mt: 2, zIndex: 0 }}>
        {label ? <LinkFont sx={{ color: 'black', mb: 1 }}>{label}</LinkFont> : null}
        <AsyncSelect
          styles={{ menu: (styles) => ({ ...styles, position: 'relative', top: 0 }) }}
          isMulti
          cacheOptions
          defaultOptions
          value={vals}
          loadOptions={this.loadOptions}
          onChange={this.handleChange}
        />
        {error ? (
          <SecondaryText sx={{ color: 'red', mt: 1 }}>{error}</SecondaryText>
        ) : null}
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    userSearch: state.user.search,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        searchUser,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AsyncAdminField);
